export default "/assets/images/wcf-v2.1613980207ca4bb2.webp";